/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { ContentType, Icon } from '@insticator/insticator-ui'; // iui-material
import Embed from 'material/embeds/embed/embed_container';
import Delete from 'material/embeds/content/edit/delete/delete_container';
import Content from 'material/embeds/content/content_container';
// utils
import { generateId } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/contentcard/contentcard_styles';



/* ========== ~~~~~~~~~~ EMBED : CONTENT CARD ~~~~~~~~~~ ========== */
const ContentCard = (props) => {

    const isSelected = () => {
        const selectedContent = props.selectedContent === 'none' ? '0' : props.selectedContent;
        return selectedContent === props.contentId && props.isClickable;
    };
    const _renderDeleteButton = () => {
        if (props.organize) return null;
        const contentData = props.contents[props.contentId];
        const isSaved = !!contentData.questionBased.contentUUID || !!contentData.story.contentUUID;
        if(!isSaved){
            return  <Delete contentId={props.contentId} optionId={null} position={`bottom right`} />
        }
    };
    return (
        <div id={`contentcard-${generateId()}`} className={`contentcard ${props.classes.contentcard} ${props.type} ${props.size} clickable-${props.isClickable} selected-${isSelected()}`}>
            {props.contentOrder !== 'ordered' ? null :
                <div className={`contentnumber`}>
                    {props.number}
                </div>
            }
            {_renderDeleteButton()}
            <div className={`contentvisual`} onClick={props.processClick}>
                <ContentType contentId={props.contentId} type={props.type} text={props.text} selectable={false} isLive={true} />
                <Embed isEditable={false} >
                    <Content type={props.type} contentId={props.contentId} isEditable={false} />
                </Embed>
                <div className={`overlay`}><Icon name={`check-circle`} /></div>
            </div>
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ContentCard);
